import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Text } from './../Typography';
import { Picture } from 'react-responsive-picture';
import { GridRow } from './../Grid';

export const Items = styled(GridRow)`
  @media screen and (max-width: 768px) {
    > *:last-child {
      display: none;
    }
  }
`;
